module.exports = __webpack_public_path__ + "img/3p.87c6ba10.png";